import { lightPalette } from "../palette";

export const MuiTexField = {
  MuiTextField: {
    styleOverrides: {
      root: {
        backgroundColor: "transparent",
        "& fieldset": {
          borderColor: lightPalette.primary.main,
        },
        "& input, & .MuiInputBase-root": {
          color: lightPalette.text.secondary,
          backgroundColor: "transparent",
        },
        ".MuiInputBase-root.MuiOutlinedInput-root:hover fieldset": {
          borderColor: lightPalette.text.secondary,
        },
      },
      outlined: {},
      contained: {},
    },
  },
};
